


//regler megamenu titres accessibilité
$(document).ready(function() {
  $('.dropdown_column__menu > ul.dropdown_title > li > a').attr('aria-hidden', 'true');
});

$(document).ready(function() {
  $('.dropdown_column__menu > ul.dropdown_title > li > a').each(function() {
    $(this).replaceWith($('<span>').html($(this).html()).addClass($(this).attr('class')));
  });
});

// fin regler megamenu titres accessibilité

//conteneur produit

function ajouterDivConteneur() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    $('[data-section-type="product-template"] .grid-id-block-grid_open_1, [data-section-type="product-template"] .grid-id-block-grid_open_2').wrapAll('<div class="conteneur"></div>');
    $('.conteneur').wrapAll('<div class="conteneur-main-produit"></div>');
  }
}

$(document).ready(ajouterDivConteneur);  // Appeler la fonction au chargement de la page



//ajout id descriptions pour lien
$(document).ready(function() {
  $('[data-section-type="product-template"] .grid-item.small--one-whole.full-width').attr('id', 'description-de-mon-article');
});


//ajout conteneur images+infos page produit
/*
function ajouterDivConteneur() {
  $('.grid-id-block-grid_open_1, .grid-id-block-grid_open_2').wrapAll('<div class="conteneur"></div>');
}


$(document).ready(ajouterDivConteneur); 
*/
//fin ajout conteneur images+infos page produit

// cacher badges fiches produits chaines
var img = document.querySelector('.product-description.rte img[src="https://cdn.shopify.com/s/files/1/0284/8269/9323/files/unnamed-4_480x480.png?v=1578602022"]');

// Vérification si l'élément a été trouvé
if (img && img instanceof HTMLElement) {
  // Masquer l'élément
  img.style.display = 'none';
}

// fin cacher badges fiches produits chaines


//test code tableau blanc

$(document).ready(function() {
  // Sélectionne le tableau
  var table = $('table');

  // Vérifie si le tableau existe
  if (table.length > 0) {
    // Vérifie si le tableau n'a pas déjà l'ID et la classe
    if (!table.attr('id')) {
      // Ajoute l'ID
      table.attr('id', 'tablex');
    }
    if (!table.hasClass('discount-table')) {
      // Ajoute la classe
      table.addClass('discount-table');
    }
    
    // Appelle la fonction wrapTable() après que l'ID et la classe ont été ajoutés
    wrapTable();
  }
});


//fin code


//new image header avec exceptions et placeholder

// Sélectionnez l'élément image à cibler
var img = document.querySelector('.img-header-xprt');

// Tableau de couleurs de placeholder basées sur le site Rolex
var placeholderColors = [
  "#1A2E39", // Bleu foncé
  "#A9B8C1", // Gris clair
  "#C4A783", // Or
  "#4F666A", // Gris foncé
  "#0F4A5C"  // Bleu-vert foncé
];

// Tableaux d'URL d'exception
var exceptionURL1 = ["https://montre-de-poche-gousset.com/collections/montre-bracelet", "https://montre-de-poche-gousset.com/collections/montre-foulard", "https://montre-de-poche-gousset.com/collections/montre-de-poche-gousset-femme", "https://montre-de-poche-gousset.com/collections/montre-collier"];
var exceptionURL2 = ["/chemin/exception4", "/chemin/exception5"];

// Images de fond pour les exceptions d'URL
var exceptionBackgroundsPC1 = [
  // Liste des images de fond pour exceptionURL1 sur PC - mag femme pc
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-10-pc.jpg?v=1682863582',  
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-26-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-16-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-15-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-24-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-25-pc.jpg?v=1682866386',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-20-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-18-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-23-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-17-pc.jpg?v=1682866386',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-19-pc.jpg?v=1682866386',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-21-pc.jpg?v=1682866386',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-22-pc.jpg?v=1682866387'
];

var exceptionBackgroundsMobile1 = [
  // Liste des images de fond pour exceptionURL1 sur mobile - mag femme mobile
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-28.jpg?v=1682917667',  
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-30.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-29.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-18.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-19.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-16.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-25.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-17.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-15.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-23.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-26.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-27.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-21.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-20.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-22.jpg?v=1682917666'
];

var exceptionBackgroundsPC2 = [
  // Liste des images de fond pour exceptionURL2 sur PC
];

var exceptionBackgroundsMobile2 = [
  // Liste des images de fond pour exceptionURL2 sur mobile 
];

// Créer un tableau d'images de fond pour la vue PC - mag homme pc
var backgroundsPC = [
  // Liste des images de fond par défaut pour PC
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-2-pc.jpg?v=1682856649',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-6-pc.jpg?v=1682863427',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-5-pc.jpg?v=1682863427',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-7-pc.jpg?v=1682863427',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-4-pc.jpg?v=1682863427',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-8-pc.jpg?v=1682863427',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-13-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-12-pc.jpg?v=1682866386',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-14-pc.jpg?v=1682866387',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-11-pc.jpg?v=1682866386'
  
];

// Créer un tableau d'images de fond pour la vue mobile - mag homme mobile
var backgroundsMobile = [
  // Liste des images de fond par défaut pour mobile
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/Sans-titre-2_d39d7b71-d313-4315-aa38-06055ec2011d.jpg?v=1682855903',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-12.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-7.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-4.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-11.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-3.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-10.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-13.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-2.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-6.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-5.jpg?v=1682917666',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-8.jpg?v=1682917665',
  'https://cdn.shopify.com/s/files/1/0284/8269/9323/files/fond-montre-a-gousset-1.jpg?v=1682917666'
];

// Fonction pour définir une couleur de placeholder aléatoire
function setRandomPlaceholderColor() {
  if (img) {
    var randomIndex = Math.floor(Math.random() * placeholderColors.length);
    var randomColor = placeholderColors[randomIndex];
    img.style.backgroundColor = randomColor;
  }
}

// Appliquer une couleur de placeholder aléatoire
setRandomPlaceholderColor();

// Fonction pour vérifier si l'URL contient un certain chemin
function checkURLPath(paths) {
  return paths.some(function(path) {
    return window.location.href.indexOf(path) !== -1;
  });
}

// Remplacez les tableaux d'images de fond si l'URL correspond à l'une des exceptions
if (checkURLPath(exceptionURL1)) {
  backgroundsPC = exceptionBackgroundsPC1;
  backgroundsMobile = exceptionBackgroundsMobile1;
} else if (checkURLPath(exceptionURL2)) {
  backgroundsPC = exceptionBackgroundsPC2;
  backgroundsMobile = exceptionBackgroundsMobile2;
}

// Fonction pour mettre à jour le fond en fonction de la taille de l'écran
function updateBackground() {
   if (img) {
  // Générer un nombre aléatoire entre 0 et le nombre d'images de fond
  var randomIndex = Math.floor(Math.random() * backgroundsPC.length);
  
  // Créer une URL pour l'image de fond aléatoire en fonction de l'index aléatoire
  var bgUrlPC = backgroundsPC[randomIndex];
  var bgUrlMobile = backgroundsMobile[randomIndex];

  // Définir l'image de fond pour l'élément image en fonction de la taille de l'écran
  if (window.matchMedia("(min-width: 768px)").matches) {
    img.style.backgroundImage = 'url(' + bgUrlPC + ')';
    img.style.backgroundSize = 'cover'; // étirer l'image pour couvrir tout l'élément
    img.style.backgroundPosition = 'center'; // centrer l'image
  } else {
    img.style.backgroundImage = 'url(' + bgUrlMobile + ')';
    img.style.backgroundSize = 'cover';
    img.style.backgroundPosition = 'center';
  }
}
}

// Écouter l'événement resize pour mettre à jour le fond en cas de changement de résolution
// window.addEventListener('resize', function() {
//  updateBackground();
// });

// Appeler la fonction une première fois pour initialiser le fond
updateBackground();


// FIn



//image avec data se charge au scroll 
function createPlaceholder(w, h) {
    var placeholder = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'%3E%3C/svg%3E`;
    return placeholder;
}

document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll("img[data-src], source[data-srcset]");

  images.forEach(image => {
    var width = image.getAttribute('width') || 100;
    var height = image.getAttribute('height') || 100;
    if (image.tagName.toLowerCase() == 'img') {
      image.src = createPlaceholder(width, height);
    }
  });

  const config = {
    rootMargin: "0px 0px 500px 100px",
    threshold: 0
  };

  let observer;

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(onIntersection, config);
    images.forEach(image => {
      observer.observe(image);
    });
  } else {
    console.log("Intersection Observer not supported");
    Array.from(images).forEach(image => loadImage(image));
  }

  function onIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
        loadImage(entry.target);
      }
    });
  }

  function loadImage(image) {
    image.onload = function() {
        image.classList.add("loaded");
    };
    if (image.tagName.toLowerCase() == 'img') {
      image.src = image.dataset.src;
    } else if (image.tagName.toLowerCase() == 'source') {
      image.srcset = image.dataset.srcset;
    }
  }
});



//ajout class images blog
$('.block-f1d5ed86-ce77-4221-9839-0fe912ffe20f img').addClass('centered');
//ajout conteneur images blog
$('.block-f1d5ed86-ce77-4221-9839-0fe912ffe20f img').wrap('<div class="image-container-blog"></div>');

//fin ajout class image blog

//enlever balises vides

const blogParagraphs = document.querySelectorAll('.blog-section p, .blog-section h2, .blog-section h3');
for (let i = 0; i < blogParagraphs.length; i++) {
  const element = blogParagraphs[i];
  if ((element.textContent.trim() === '' || element.innerHTML.trim() === '&nbsp;') && !element.querySelector('*')) {
    element.style.display = 'none';
  }
}

//fin balises vides


//enelver deux points tableau produits

document.addEventListener("DOMContentLoaded", function() {
  const table = document.getElementById("tablex");
  if (table) {
    const rows = table.getElementsByTagName("tr");
    for (let i = 0; i < rows.length; i++) {
      const cell = rows[i].getElementsByTagName("td")[0];
      const text = cell.textContent.trim();
      if (text.endsWith(" :")) {
        cell.textContent = text.slice(0, -1);
        cell.classList.add("without-colon");
      }
    }
  }
});


//code filtres page accueil


const categories = document.querySelector(".categories");
const backButton = document.querySelector(".back-btn");
const choicesContainers = document.querySelectorAll(".choices");

function showChoices(category) {
  const choices = document.getElementById(`${category}-choices`);
  if (choices) {
    categories.style.display = "none";
    choices.style.display = "flex";
    if (backButton) {
      backButton.style.display = "block";
    }
  }
}

function hideChoices() {
  choicesContainers.forEach((choices) => {
    choices.style.display = "none";
  });
  categories.style.display = "flex";
  if (backButton) {
    backButton.style.display = "none";
  }
}

function scrollToTop(element) {
  element.scrollIntoView({ behavior: "smooth", block: "start" });
}

document.querySelectorAll(".category").forEach((category) => {
  category.addEventListener("click", (event) => {
    event.preventDefault();
    showChoices(category.id);
    const sectionTitle = document.querySelector(".section-title");
    if (sectionTitle) {
      scrollToTop(sectionTitle);
    }
  });
});

if (backButton) {
  backButton.addEventListener("click", hideChoices);
}

document.addEventListener("DOMContentLoaded", function () {
  history.replaceState(null, "", location.href.split("#")[0]);
});









//fin code filtres page accueil


//Code texte collection pour mobile
document.addEventListener('DOMContentLoaded', function() {
    var p = document.querySelector('.txt-contain p');
  
    //if (p.textContent.length > 150) {
  if (p !== null && p.textContent.length > 150) {
      var readMoreBtn = document.createElement('button');
      readMoreBtn.classList.add('read-more-btn-mobile');
      readMoreBtn.textContent = 'Continuer à lire';
      p.parentNode.insertBefore(readMoreBtn, p.nextSibling);

      if (window.innerWidth <= 767) {
        readMoreBtn.style.display = 'block';
      }

      readMoreBtn.addEventListener('click', function() {
        p.style.height = 'auto';
        p.style.webkitMaskImage = 'none';
        p.style.maskImage = 'none';
        readMoreBtn.style.display = 'none';
      });

      window.addEventListener('resize', function() {
        if (window.innerWidth <= 767) {
          readMoreBtn.style.display = 'block';
        } else {
          readMoreBtn.style.display = 'none';
        }
      });
    }
  });

//FIn Code texte collection pour mobile

$('.discount-table').attr('id', 'tablex');
$('.discount-table td').attr('id', 'tablez');
$('.discount-table tr').attr('id', 'tabley');

// Sélectionnez tous les éléments td qui ont l'attribut style contenant "!important"
var tdElements = document.querySelectorAll("td[style*='!important']");

// Parcourez chaque élément td sélectionné
for (var i = 0; i < tdElements.length; i++) {
  var tdElement = tdElements[i];

  // Supprimez les propriétés "background" et "border-color" qui ont la valeur "!important"
  tdElement.style.removeProperty("background");
  tdElement.style.removeProperty("border-color");
}

// Sélectionnez le tableau et ajoutez une div wrapper
function wrapTable() {
  var table = document.querySelector('table#tablex.discount-table');
  //ajout correction pour erreur console
   // (ancienne ligne mis à jour pour les tableaux blancs dsers : if (table !== null) {
   if (table !== null && !table.parentNode.classList.contains('table-wrapper')) {
     //fin
  var wrapper = document.createElement('div');
  wrapper.classList.add('table-wrapper');
  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);

}
  }

// Attendez que le document soit entièrement chargé avant d'exécuter la fonction wrapTable
document.addEventListener('DOMContentLoaded', function() {
  wrapTable();
});




//fonction bouton page produit // JavaScript
$(document).ready(function () {
  // Récupère les lignes du tableau
  var table = $('.discount-table');
  var rows = table.find('tr');

  // Cache les lignes après la 6e
  for (var i = 6; i < rows.length; i++) {
    $(rows[i]).addClass('hidden');
  }

  // Crée l'élément div pour le bouton
  var buttonWrapper = $('<div>').addClass('button-wrapper');
  table.after(buttonWrapper);

  // Crée le bouton "Afficher plus"
  var button = $('<button>').html('Afficher plus').addClass('show-more');
  buttonWrapper.append(button);

  // Ajoute un élément div avec la classe "table-container" autour du tableau
  table.wrap('<div class="table-container"></div>');

  // Ajoute un élément div avec la classe "fade-effect" à la fin du conteneur "table-container"
  var fadeEffect = $('<div>').addClass('fade-effect');
  table.parent().append(fadeEffect);

  // Ajoute un écouteur d'événements au bouton "Afficher plus"
  var showMoreButton = $('.show-more');
  showMoreButton.on('click', function () {
    rows.each(function () {
      $(this).removeClass('hidden');
    });
    fadeEffect.hide();
    buttonWrapper.hide();
  });
});



//supprimer hauteur tableau html fiches produits
$(document).ready(function () {
  // Sélectionne le tableau avec la classe 'discount-table'
  var table = $('.discount-table');

  // Modifie la hauteur du tableau
  table.css('height', 'auto');

  // Le reste du code pour afficher/masquer les lignes et le bouton "Afficher plus"
  // ...
});









//fin bouton produit




(function() {
// estimer date de livraison
if(document.getElementById('fromDate')) {
  
  var dateDebut = 6;
  var dateFin = 16;

  var fromDate = Date.today().addDays(dateDebut);
  if (fromDate.is().saturday() || fromDate.is().sunday()) { 
    fromDate = fromDate.next().monday();
  }
  var toDate = Date.today().addDays(dateFin);
  if (toDate.is().saturday() || toDate.is().sunday()) { 
    toDate = toDate.next().monday(); 
  }
  document.getElementById('fromDate').innerHTML = fromDate.toString('dd/MM');
  document.getElementById('toDate').innerHTML = toDate.toString('dd/MM');
}
})();

//lire +
    var dgReadMoreText1 = "+ En savoir plus";
var dgReadMoreText2 = "- En savoir moins";

function dgReadMore(id) {
  var dots = document.getElementById("dg-rm-dots-"+id);
  var moreText = document.getElementById("dg-rm-more-"+id);
  var btnText = document.getElementById("dg-rm-btn-"+id);

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = dgReadMoreText1;
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = dgReadMoreText2;
    moreText.style.display = "inline";
  }
}
    
    //traduction color-size
    $(document).ready(function(){
 $(".swatch .header").text(function () { 
 return $(this).text().replace("Color", "Couleur");
 });
 $(".swatch .header").text(function () { 
 return $(this).text().replace("Size", "Taille");
 });
       $(".swatch .header").text(function () { 
 return $(this).text().replace("--Choose", "Choisir");
 });
});

//code pour les pages de vidéo produits
window.onload = function() {
  var videoWrappers = document.querySelectorAll('.video-wrapper');

  videoWrappers.forEach(function(videoWrapper) {
    var parentDiv = videoWrapper.parentElement;

    if (parentDiv.style.position === 'relative' && parentDiv.style.paddingTop === '56.25%') {
      parentDiv.style.position = '';
      parentDiv.style.paddingTop = '0%';
    }
  });
};



//empêcher chargement zone en bas des collections zone promo + collections + avantages mobile
 window.addEventListener('DOMContentLoaded', function() {
  var blocColFoot = document.getElementById('avantages-mobile');
  var bonPlan = document.getElementById('bon-plan');
  //var blocColFoot = document.getElementById('bloc-col-foot');
   var avantagesmobil = document.getElementById('avantages-mobile');
  
  avantagesMobile(); // appel de la fonction après sa définition

  if (blocColFoot) {
    blocColFoot.remove();
  }

  if (bonPlan) {
    bonPlan.remove();
  }

  if (blocColFoot) {
    blocColFoot.remove();
  }

if (avantagesmobil) {
   avantagesmobil.remove();
  }
   
});

function avantagesMobile() {
  // code pour la fonction avantagesMobile
}

//li page prod

document.addEventListener('DOMContentLoaded', function() {
  var listItems = document.querySelectorAll('.product-description.rte li');

  // Parcourt chaque élément li dans la liste
  listItems.forEach(function(item) {
    // Crée le conteneur pour l'icône et le texte
    var container = document.createElement('div');
    container.classList.add('icon-text-container');

    // Crée l'élément icône
    var icon = document.createElement('i');
    icon.classList.add('fa', 'fa-check-circle');
    icon.setAttribute('aria-hidden', 'true');

    // Insère l'icône dans le conteneur
    container.appendChild(icon);

    // Copie le contenu de l'élément li dans le conteneur
    var text = item.innerHTML;
    container.innerHTML += text;

    // Remplace le contenu de l'élément li par le conteneur
    item.innerHTML = '';
    item.appendChild(container);

    // Crée l'élément hr
    var hr = document.createElement('hr');

    // Insère la ligne de séparation après l'élément li
    item.parentNode.insertBefore(hr, item.nextSibling);
  });
});



